/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../../_chunks/dep-f7837681.mjs';
import { _ as _defineProperty } from '../../../_chunks/dep-a26b9c60.mjs';
import { isVNode, defineComponent, ref, watch, createVNode, mergeProps } from 'vue';
import '../../../_chunks/dep-6f3e4f56.mjs';
import { a as _createCompounder } from '../../../_chunks/dep-17446155.mjs';
import props from '../../props.mjs';
import { FORMATS } from '../../const.mjs';
import { Select, Option } from '../../../select/index.mjs';
import FormatInputs from './inputs.mjs';
import { useBaseClassName } from '../../hooks.mjs';
import '../../../_chunks/dep-6bcce672.mjs';
import '../../../_chunks/dep-b333ab93.mjs';
import '../../../_chunks/dep-7ad89920.mjs';
import '../../../_chunks/dep-b1060562.mjs';
import '../../../_chunks/dep-0d1bd08c.mjs';
import '../../../_chunks/dep-c5d88cfe.mjs';
import '../../../_chunks/dep-36563716.mjs';
import '../../../_chunks/dep-8049d2e0.mjs';
import '../../../_common/js/color-picker/constants.mjs';
import '../../../select/select.mjs';
import '../../../_chunks/dep-9c7a32ff.mjs';
import '../../../_chunks/dep-89b33ff6.mjs';
import '../../../_chunks/dep-d31cdc42.mjs';
import '../../../_chunks/dep-6e04bcaa.mjs';
import '../../../_chunks/dep-28ae3cda.mjs';
import '../../../_chunks/dep-e50fa7b0.mjs';
import '../../../_chunks/dep-97c71289.mjs';
import '../../../_chunks/dep-4efc69ee.mjs';
import '../../../_chunks/dep-ae08d6c4.mjs';
import '../../../_chunks/dep-7211604f.mjs';
import '../../../_chunks/dep-31e6cb80.mjs';
import '../../../_chunks/dep-75df64b1.mjs';
import '../../../_chunks/dep-48b9a098.mjs';
import '../../../_chunks/dep-52c1d6a9.mjs';
import '../../../_chunks/dep-c7e4942d.mjs';
import '../../../_chunks/dep-372265bb.mjs';
import '../../../_chunks/dep-4b3e18ca.mjs';
import '../../../_chunks/dep-6043e9fc.mjs';
import '../../../_chunks/dep-b6b4eaa3.mjs';
import '../../../_chunks/dep-9239b808.mjs';
import '../../../_chunks/dep-8bda6dda.mjs';
import '../../../_chunks/dep-493c38ce.mjs';
import '../../../_chunks/dep-b56b2dc0.mjs';
import '../../../_chunks/dep-77f634fb.mjs';
import '../../../_chunks/dep-25d66c95.mjs';
import '../../../_chunks/dep-d940e2da.mjs';
import '../../../_chunks/dep-18bb982b.mjs';
import '../../../_chunks/dep-c57d8117.mjs';
import '../../../_chunks/dep-87c358ba.mjs';
import '../../../_chunks/dep-c0b45aa7.mjs';
import '../../../_chunks/dep-8a9a248b.mjs';
import '../../../_chunks/dep-53dc0ac1.mjs';
import '../../../common-components/fake-arrow.mjs';
import '../../../hooks/useConfig.mjs';
import '../../../config-provider/useConfig.mjs';
import '../../../_chunks/dep-5f6c8826.mjs';
import '../../../_chunks/dep-3a045465.mjs';
import '../../../_chunks/dep-881cffb7.mjs';
import '../../../_chunks/dep-436b338d.mjs';
import '../../../_common/js/global-config/default-config.mjs';
import '../../../_common/js/global-config/locale/zh_CN.mjs';
import '../../../_chunks/dep-2d31a683.mjs';
import '../../../_chunks/dep-3ddc95d0.mjs';
import '../../../config-provider/type.mjs';
import '../../../select-input/index.mjs';
import '../../../select-input/select-input.mjs';
import '../../../popup/index.mjs';
import '../../../popup/popup.mjs';
import '@popperjs/core';
import '../../../hooks/index.mjs';
import '../../../hooks/icon.mjs';
import '../../../hooks/slot.mjs';
import '../../../hooks/tnode.mjs';
import '../../../_chunks/dep-0a6fd248.mjs';
import '../../../_chunks/dep-b1013215.mjs';
import '../../../_chunks/dep-91fc304f.mjs';
import '../../../_chunks/dep-8747fcf0.mjs';
import '../../../utils/render-tnode.mjs';
import '../../../_chunks/dep-ec227f3f.mjs';
import '../../../hooks/useCommonClassName.mjs';
import '../../../hooks/useDefaultValue.mjs';
import '../../../hooks/useDestroyOnClose.mjs';
import '../../../hooks/useKeepAnimation.mjs';
import '../../../hooks/useRipple.mjs';
import '../../../utils/set-style.mjs';
import '../../../hooks/useVirtualScroll.mjs';
import '../../../hooks/useVModel.mjs';
import '../../../hooks/useImagePreviewUrl.mjs';
import '../../../_common/js/upload/utils.mjs';
import '../../../_common/js/log/log.mjs';
import '../../../utils/dom.mjs';
import '../../../utils/easing.mjs';
import '../../../_common/js/utils/set-style.mjs';
import '../../../popup/container.mjs';
import '../../../popup/props.mjs';
import '../../../hooks/useResizeObserver.mjs';
import '../../../utils/withInstall.mjs';
import './style/css.mjs';
import '../../../popup/type.mjs';
import '../../../select-input/props.mjs';
import '../../../select-input/useSingle.mjs';
import '../../../input/index.mjs';
import '../../../input/input.mjs';
import 'tdesign-icons-vue-next';
import '../../../input/props.mjs';
import '../../../form/hooks.mjs';
import '../../../hooks/useGlobalIcon.mjs';
import '../../../input/useInput.mjs';
import '../../../form/const.mjs';
import '../../../input/useLengthLimit.mjs';
import '../../../_common/js/log/index.mjs';
import '../../../_common/js/utils/helper.mjs';
import '../../../_chunks/dep-c45cdd10.mjs';
import '../../../_chunks/dep-ce88e3c0.mjs';
import '../../../_chunks/dep-a432d90f.mjs';
import '../../../input/useInputEventHandler.mjs';
import '../../../input/useInputWidth.mjs';
import '../../../input/input-group.mjs';
import '../../../input/input-group-props.mjs';
import '../../../input/type.mjs';
import '../../../loading/index.mjs';
import '../../../loading/directive.mjs';
import '../../../loading/plugin.mjs';
import '../../../loading/loading.mjs';
import '../../../loading/icon/gradient.mjs';
import '../../../_common/js/loading/circle-adapter.mjs';
import '../../../loading/props.mjs';
import '../../../hooks/useTeleport.mjs';
import '../../../loading/type.mjs';
import '../../../select-input/useMultiple.mjs';
import '../../../tag-input/index.mjs';
import '../../../tag-input/tag-input.mjs';
import '../../../tag-input/props.mjs';
import '../../../tag-input/hooks/useTagScroll.mjs';
import '../../../tag-input/useTagList.mjs';
import '../../../tag/index.mjs';
import '../../../tag/tag.mjs';
import '../../../tag/props.mjs';
import '../../../tag/check-tag.mjs';
import '../../../tag/check-tag-props.mjs';
import '../../../_common/js/common.mjs';
import '../../../tag/check-tag-group.mjs';
import '../../../tag/check-tag-group-props.mjs';
import '../../../tag/type.mjs';
import '../../../tag-input/hooks/useHover.mjs';
import '../../../tag-input/hooks/useDragSorter.mjs';
import '../../../tag-input/type.mjs';
import '../../../select-input/useOverlayInnerStyle.mjs';
import '../../../select-input/type.mjs';
import '../../../select/select-panel.mjs';
import '../../../_chunks/dep-7cc8d2c3.mjs';
import '../../../_chunks/dep-d23f3733.mjs';
import '../../../select/option.mjs';
import '../../../select/option-props.mjs';
import '../../../checkbox/index.mjs';
import '../../../checkbox/checkbox.mjs';
import '../../../checkbox/props.mjs';
import '../../../checkbox/constants.mjs';
import '../../../checkbox/hooks/useCheckboxLazyLoad.mjs';
import '../../../_common/js/utils/observe.mjs';
import '../../../checkbox/hooks/useKeyboardEvent.mjs';
import '../../../hooks/useDisabled.mjs';
import '../../../_chunks/dep-11ebe61f.mjs';
import '../../../checkbox/group.mjs';
import '../../../checkbox/checkbox-group-props.mjs';
import '../../../checkbox/type.mjs';
import '../../../select/helper.mjs';
import '../../../select/optionGroup.mjs';
import '../../../select/option-group-props.mjs';
import '../../../select/props.mjs';
import '../../../select/hooks/usePanelVirtualScroll.mjs';
import '../../../select/hooks/useSelectOptions.mjs';
import '../../../select/hooks/useKeyboardControl.mjs';
import '../../../select/type.mjs';
import '../../../_chunks/dep-99b45a9d.mjs';
import '../../utils/index.mjs';
import '../../../_common/js/color-picker/index.mjs';
import '../../../_common/js/color-picker/cmyk.mjs';
import '../../../_common/js/color-picker/color.mjs';
import '../../../_chunks/dep-6d195cc7.mjs';
import '../../../_chunks/dep-71e8e343.mjs';
import '../../../_common/js/color-picker/draggable.mjs';
import '../../../input-number/index.mjs';
import '../../../input-number/input-number.mjs';
import '../../../button/index.mjs';
import '../../../button/button.mjs';
import '../../../button/props.mjs';
import '../../../button/type.mjs';
import '../../../input-number/props.mjs';
import '../../../input-number/useInputNumber.mjs';
import '../../../_common/js/input-number/number.mjs';
import '../../../_common/js/input-number/large-number.mjs';
import '../../../input-number/type.mjs';
import './config.mjs';

var createCompounder = _createCompounder;

/**
 * Converts `string`, as space separated words, to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the upper cased string.
 * @example
 *
 * _.upperCase('--foo-bar');
 * // => 'FOO BAR'
 *
 * _.upperCase('fooBar');
 * // => 'FOO BAR'
 *
 * _.upperCase('__foo_bar__');
 * // => 'FOO BAR'
 */
var upperCase = createCompounder(function (result, word, index) {
  return result + (index ? ' ' : '') + word.toUpperCase();
});
var upperCase_1 = upperCase;

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !isVNode(s);
}
var FormatPanel = defineComponent({
  name: "FormatPanel",
  inheritAttrs: false,
  props: _objectSpread(_objectSpread({}, props), {}, {
    color: {
      type: Object
    },
    onModeChange: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    },
    onInputChange: {
      type: Function,
      "default": function _default() {
        return function () {};
      }
    }
  }),
  setup: function setup(props2) {
    var baseClassName = useBaseClassName();
    var formatModel = ref(props2.format);
    watch(function () {
      return [props2.format];
    }, function () {
      return formatModel.value = props2.format;
    });
    var handleModeChange = function handleModeChange(v) {
      formatModel.value = v;
      props2.onModeChange(v);
    };
    return {
      formatModel: formatModel,
      baseClassName: baseClassName,
      handleModeChange: handleModeChange
    };
  },
  render: function render() {
    var _this = this;
    var _slot;
    var formats = _toConsumableArray(FORMATS);
    var baseClassName = this.baseClassName,
      handleModeChange = this.handleModeChange;
    var newProps = _objectSpread(_objectSpread({}, this.$props), {}, {
      format: this.formatModel
    });
    var selectInputProps = _objectSpread({}, this.selectInputProps || {});
    return createVNode("div", {
      "class": "".concat(baseClassName, "__format")
    }, [createVNode("div", {
      "class": "".concat(baseClassName, "__format--item")
    }, [createVNode(Select, mergeProps({
      "size": "small",
      "class": "".concat(baseClassName, "__format-mode-select")
    }, selectInputProps, {
      "popupProps": _objectSpread({
        overlayClassName: "".concat(baseClassName, "__select-options")
      }, selectInputProps.popupProps),
      "modelValue": _this.formatModel,
      "onUpdate:modelValue": function onUpdateModelValue($event) {
        return _this.formatModel = $event;
      },
      "onChange": handleModeChange
    }), _isSlot(_slot = formats.map(function (item) {
      return createVNode(Option, {
        "key": item,
        "value": item,
        "label": upperCase_1(item),
        "style": {
          fontSize: "12px"
        }
      }, null);
    })) ? _slot : {
      "default": function _default() {
        return [_slot];
      }
    })]), createVNode("div", {
      "class": "".concat(baseClassName, "__format--item")
    }, [createVNode(FormatInputs, newProps, null)])]);
  }
});

export { FormatPanel as default };
//# sourceMappingURL=index.mjs.map
